import { render, staticRenderFns } from "./CustomInputUpload.vue?vue&type=template&id=4928e9dd&scoped=true"
import script from "./CustomInputUpload.vue?vue&type=script&lang=js"
export * from "./CustomInputUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomInputUpload.vue?vue&type=style&index=0&id=4928e9dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928e9dd",
  null
  
)

export default component.exports